import './index.styles.css'
interface Props {
  opened: boolean
}

const PlusMinus = ({ opened }: Props) => {
  const plus = (
    <path d="M0 7.5C0 7.74864 0.098772 7.9871 0.274587 8.16291C0.450403 8.33873 0.68886 8.4375 0.9375 8.4375H6.40625C6.44769 8.4375 6.48743 8.45396 6.51674 8.48326C6.54604 8.51257 6.5625 8.55231 6.5625 8.59375V14.0625C6.5625 14.3111 6.66127 14.5496 6.83709 14.7254C7.0129 14.9012 7.25136 15 7.5 15C7.74864 15 7.9871 14.9012 8.16291 14.7254C8.33873 14.5496 8.4375 14.3111 8.4375 14.0625V8.59375C8.4375 8.55231 8.45396 8.51257 8.48326 8.48326C8.51257 8.45396 8.55231 8.4375 8.59375 8.4375H14.0625C14.3111 8.4375 14.5496 8.33873 14.7254 8.16291C14.9012 7.9871 15 7.74864 15 7.5C15 7.25136 14.9012 7.0129 14.7254 6.83709C14.5496 6.66127 14.3111 6.5625 14.0625 6.5625H8.59375C8.55231 6.5625 8.51257 6.54604 8.48326 6.51674C8.45396 6.48743 8.4375 6.44769 8.4375 6.40625V0.9375C8.4375 0.68886 8.33873 0.450403 8.16291 0.274587C7.9871 0.098772 7.74864 0 7.5 0C7.25136 0 7.0129 0.098772 6.83709 0.274587C6.66127 0.450403 6.5625 0.68886 6.5625 0.9375V6.40625C6.5625 6.44769 6.54604 6.48743 6.51674 6.51674C6.48743 6.54604 6.44769 6.5625 6.40625 6.5625H0.9375C0.68886 6.5625 0.450403 6.66127 0.274587 6.83709C0.098772 7.0129 0 7.25136 0 7.5H0Z" />
  )

  const minus = (
    <path d="M0.9375 8.4375H14.0625C14.3111 8.4375 14.5496 8.33873 14.7254 8.16291C14.9012 7.9871 15 7.74864 15 7.5C15 7.25136 14.9012 7.0129 14.7254 6.83709C14.5496 6.66127 14.3111 6.5625 14.0625 6.5625H0.9375C0.68886 6.5625 0.450403 6.66127 0.274587 6.83709C0.098772 7.0129 0 7.25136 0 7.5C0 7.74864 0.098772 7.9871 0.274587 8.16291C0.450403 8.33873 0.68886 8.4375 0.9375 8.4375Z" />
  )

  return (
    <svg
      viewBox="0 0 15 15"
      width="15"
      height="15"
      xmlns="http://www.w3.org/2000/svg"
      className={'PlusMinus_plusMinus'}
    >
      {!opened && plus}
      {opened && minus}
    </svg>
  )
}

export default PlusMinus
